// https://www.dbos.dev/jobs

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaStartBuildingForFree } from '@components/layout/FooterCtas';

export function JobsPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaStartBuildingForFree />}>
      <section className="hero-title">
        <h1 className="text-heading-h1">Available positions</h1>
        <p className="text-body text-alignment-left">
          Scale with us, and join the future of cloud software development technology.
          <br />
          Browse our available positions.
        </p>
      </section>
      <div className="job-list-wrapper w-dyn-list">
        <div role="list" className="job-list w-dyn-items">
          <div role="listitem" className="job-item w-dyn-item">
            <a href="/jobs/keep-me-in-mind" className="job-overview-wrapper w-inline-block">
              <div className="w-layout-vflex flex-block-3">
                <h2 className="text-heading-h4">Don't see an open position you'd like to fill?</h2>
                <div className="w-layout-hflex flex-block-2">
                  <div className="text-body">DBOS</div>
                  <div className="text-body">•</div>
                  <div className="text-body">Full-time</div>
                  <div className="text-body">•</div>
                  <div className="text-body">United States, Remote</div>
                </div>
              </div>
              <div className="code-embed-4 w-embed">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {'\n'}
                  <path
                    d="M7 17.5L17 7.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  {'\n'}
                  <path
                    d="M7 7.5H17V17.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  {'\n'}
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
